import { inject, Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { ConfigService } from './config.service';
import { GrowthBook, WidenPrimitives } from '@growthbook/growthbook';

const PLATFORM = 'web';

export enum Features {
    CHECKOUT_TYPE = 'checkout-type',
    YEARLY_PRICE_PER_MONTH = 'year-price-monthly',
}

// De Experiment enum is handig voor je eigen overzicht, 
// maar de SDK gebruikt de Feature Key om de waarde op te halen.
export enum Experiments {
    CHECKOUT_FLOW_TEST = 'one-checkout-flow-test', // Matcht de "Tracking Key",
	YEAR_PRICE_MONTHLY_TEST = 'year-price-montly-test',
}

@Injectable({
	providedIn: 'root'
})
export class GrowthbookService {

	private configService = inject(ConfigService);
    private growthbook: GrowthBook;

	public async init(): Promise<void> {
		this.growthbook = new GrowthBook({
			apiHost: "https://cdn.growthbook.io",
			clientKey: this.configService.growthbookClientKey,
			enableDevMode: true,
			trackingCallback: (experiment, result) => {
				// Register as super property so every subsequent event (Signup Started,
				// Signup Completed, etc.) automatically carries the variant info.
				mixpanel.register({
					[`experiment_${experiment.key}`]: result.value,
				});

				mixpanel.track("$experiment_started", {
					"featureId": result.featureId,
					"Experiment ID": experiment.key,
					"Variant ID": result.key,
					"Experiment result": result.value,
					'Platform': PLATFORM
				});
			},
		});

		await this.growthbook.init({ timeout: 2000 });
		this.setAttributes();
	}

    public setAttributes(userId?: string): void {
		let id = userId || null;

		if(!userId) {
			id = localStorage.getItem('gb_anonymous_id');

			if(!id){
				id = 'anon_' + Math.random().toString(36).substring(2, 11);
				localStorage.setItem('gb_anonymous_id', id);
			}
		}

        this.growthbook.setAttributes({
            id: id,
            platform: PLATFORM
        });
    }

    public isFeatureEnabled(feature: string): boolean {
        return this.growthbook.isOn(feature);
    }

    public getFeatureValue<T>(feature: string, defaultValue: T): WidenPrimitives<T> {
        return this.growthbook.getFeatureValue(feature, defaultValue);
    }
}
